module.exports = __webpack_public_path__ + "img/navbar-search-light.eb487069.svg";